import { Link } from 'react-router-dom';
import { homeFaq } from '@/content/faq';
import { supportWhatsAppHref } from '@/lib/supportChat';

export function HomeFaq({ appsCount, sectorsCount, fromPrice, topPrice }: { appsCount: number; sectorsCount: number; fromPrice: string; topPrice: string }) {
  return (
    <section className="hx-sec soft" id="faq">
      <div className="hx-wrap">
        <div className="hx-faq">
          <div className="hx-what rev">
            <span className="hx-label blue">Operax em resumo</span>
            <h2 className="hx-h2">O que é a Operax?</h2>
            <p>
              A Operax é uma plataforma brasileira de CRM e atendimento no WhatsApp oficial da Meta. Reúne inbox com
              filas, funil de vendas e {appsCount} apps ativáveis, como Hub Comercial para marketplaces, CoreMed para
              clínicas, IA, PDV, estoque, Pix, NF-e/NFS-e e contratos, em um único login.
            </p>
            <dl>
              <dt>Para quem</dt>
              <dd>
                Clínicas, varejo, vendedores de marketplace, serviços, oficinas, restaurantes, associações, cursos e
                eventos ({sectorsCount} setores)
              </dd>
              <dt>Canal</dt>
              <dd>API oficial do WhatsApp (Cloud API), Provedor de Tecnologia verificado pela Meta</dd>
              <dt>Preço</dt>
              <dd>
                De {fromPrice} a {topPrice}/mês; Enterprise sob consulta
              </dd>
              <dt>Contrato</dt>
              <dd>Mensal, sem fidelidade e sem multa</dd>
            </dl>
          </div>
          <div className="hx-qa">
            {homeFaq.map((item, i) => (
              <details key={item.question}>
                <summary>{item.question}</summary>
                <p>
                  {item.answer}
                  {i === homeFaq.length - 1 && (
                    <>
                      {' '}
                      <Link to="/termos-de-uso">Termos de Uso</Link> · <a href={supportWhatsAppHref()}>WhatsApp</a>
                    </>
                  )}
                </p>
              </details>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
